import { Chat, Message } from "../types";
import * as Yup from "yup";

export const formatMessageTime = (date: Date): string => {
  const now = new Date();
  const diffInHours = (now.getTime() - date.getTime()) / (1000 * 60 * 60);

  if (diffInHours < 24) {
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  }
  return date.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
};

export const formatChatDate = (date: Date): string => {
  return date.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
};

export const generateChatTitle = (firstMessage: string): string => {
  // Generate a title from the first message
  const words = firstMessage.split(" ").slice(0, 6);
  return words.join(" ") + (words.length >= 6 ? "..." : "");
};

export const isMessageFromToday = (date: Date): boolean => {
  const today = new Date();
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
};

export const getUnreadMessageCount = (
  chat: Chat,
  lastReadTimestamp?: Date
): number => {
  if (!lastReadTimestamp) return chat.messages.length;

  return chat.messages.filter(
    (message) => message.timestamp > lastReadTimestamp
  ).length;
};

export const validateMessage = (content: string): boolean => {
  return content.trim().length > 0 && content.trim().length <= 1000;
};

export interface AudioMessageProps {
  message: Message;
  isUser: boolean;
  timestamp: Date;
  isRead?: boolean;
  askFerret?: boolean;
}

type MsgObj = {
  id: string;
  message?: string;
  safetyReasons?: string;
  // add other keys present in your data
};

export function containsSelfHarmSignalTS(items: MsgObj[]): boolean {
  const re =
    /\b(self-?harm|harm\b|suicid|kill(?:\s+myself|\b)|want\s+to\s+die|end\s+my\s+life)\b/i;
  return items.some((item) =>
    [item.safetyReasons, item.message].some(
      (f) => typeof f === "string" && re.test(f)
    )
  );
}

export const crisisModalScheme = Yup.object({
  safeText: Yup.string()
    .required("This field is required")
    .test("contains-safe", 'Please include the word "safe".', (value) => {
      if (!value) return false;
      return value.toLowerCase().includes("safe");
    }),
});
